<template>
  <div class="c-home">
    <template v-if="popular && popular.length > 0">
      <h3 class="pt-3">{{ translations['questions-title'] }}</h3>
      <c-columns :list="popular"/>
      <div class="h-12"/>
    </template>
    <c-alert
      :actions="supportActions"
      :text="translations['support-text']"
      :title="translations['support-title']"
      @on-click="onSupport"
    />
    <template v-if="recommend && recommend.length > 0">
      <div class="h-12"/>
      <h6>{{ translations['recommend-title'] }}</h6>
      <div class="font-body2">{{ translations['recommend-text'] }}</div>
      <div class="h-6"/>
      <c-list
        :border="true"
        :item-attrs="{ iconTrailing: 'chevron-right', hoverNone: true }"
        :list="recommend"
        class="border-y"
        size="medium"
      />
    </template>
  </div>
</template>

<script>
import CAlert from '@/components/CAlert'
import CColumns from '@/components/CColumns'
import CList from '@/components/CList'
import { computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import Translation from 'dcode/classes/Translation'
import setTitle from '@/functions/setTitle'

export default {
  name: 'HomeView',
  components: {
    CAlert,
    CColumns,
    CList
  },
  setup () {
    const store = useStore()
    /**
     * @type {Object.<string, string>}
     */
    const translations = Translation.getByList([
      'questions-title',
      'recommend-text',
      'recommend-title',
      'support-button',
      'support-text',
      'support-title',
      'title'
    ])

    const supportActions = [
      { text: translations['support-button'] }
    ]

    onMounted(() => store.dispatch('setPost', {
      notFound: false,
      breadcrumbs: [],
      banner: false
    }))

    setTitle(translations.title)

    return {
      popular: computed(() => store.getters.getPopular),
      recommend: computed(() => store.getters.getRecommend),
      supportActions,
      translations,
      onSupport: () => document.querySelector('[href="#callback"]')?.click()
    }
  }
}
</script>
